// extracted by mini-css-extract-plugin
export default {"container":"PageLoader_container__oIUFB"};